export const displayResultsBasedOnScreenHeightMixin = {
  methods: {
    displayResultsBasedOnScreen() {
      console.log(screen);
      if (screen.height < 400) {
        this.pageCount = 10;
      } else if (screen.height <= 720) {
        this.pageCount = 5;
      } else if (screen.height > 720 && screen.height <= 864 && window.devicePixelRatio == 1) {
        this.pageCount = 9;
        // console.log(`resolution: ${screen.height} dpi: ${window.devicePixelRatio}`);
      } else if (screen.height > 720 && screen.height <= 864 && window.devicePixelRatio == 1.25) {
        this.pageCount = 8;
        //  console.log(`resolution: ${screen.height} dpi: ${window.devicePixelRatio}`);
      } else if (screen.height > 864 && screen.height <= 1024 && window.devicePixelRatio == 1.25) {
        this.pageCount = 9;
        // console.log(`resolution: ${screen.height} dpi: ${window.devicePixelRatio}`);
      } else if (screen.height > 864 && screen.height <= 1024 && window.devicePixelRatio == 1) {
        this.pageCount = 12;
        // console.log(`resolution: ${screen.height} dpi: ${window.devicePixelRatio}`);
      } else if (screen.height > 1024 && screen.height <= 1080 && window.devicePixelRatio == 1.25) {
        this.pageCount = 9;
        // console.log(`resolution: ${screen.height} dpi: ${window.devicePixelRatio}`);
      } else if (screen.height > 1024 && screen.height <= 1080 && window.devicePixelRatio == 1) {
        this.pageCount = 11;
        // console.log(`resolution: ${screen.height} dpi: ${window.devicePixelRatio}`);
      } else {
        this.pageCount = 15;
        // console.log(`resolution: ${screen.height} dpi: ${window.devicePixelRatio}`);
      }
    },
  },
};
